import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { userApi } from 'features/user/query';
import { type TUserState } from 'features/user/types';

const initialState: TUserState = {
  userList: null,
  currentUser: null,
  isFetchingCurrentUser: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: builder => {
    const { GetUserDetailList, GetCurrentUser } = userApi.endpoints;

    builder
      .addMatcher(GetUserDetailList.matchFulfilled, (state, { payload }) => {
        state.userList = payload.userDetails ?? null;
      })
      .addMatcher(
        isAnyOf(
          GetUserDetailList.matchPending,
          GetUserDetailList.matchRejected
        ),
        state => {
          state.userList = null;
        }
      );

    builder
      .addMatcher(GetCurrentUser.matchPending, state => {
        state.isFetchingCurrentUser = true;
      })
      .addMatcher(GetCurrentUser.matchFulfilled, (state, action) => {
        state.currentUser = action.payload;
        state.isFetchingCurrentUser = false;
      })
      .addMatcher(GetCurrentUser.matchRejected, state => {
        state.currentUser = null;
        state.isFetchingCurrentUser = false;
      });
  },
});

export const userReducer = userSlice.reducer;
